import dayjs from 'dayjs';

/**
 * Returns amount of time elapsed since the given date
 * (positive if current day is in future, negative if it is in past)
 */
const getElapsedTimeMs = (timeElapsedSince: Date): number =>
  dayjs().diff(dayjs(timeElapsedSince), 'milliseconds');

export default getElapsedTimeMs;
